import { useState, useEffect, useMemo } from 'react'
import { doc, getDoc } from 'firebase/firestore'
import { ExposureData } from '../../../../../types/FirestoreUser'
import { calculateAge } from '../../../../../utils/calculateAge'
import FirestoreUser from '../../../../../types/FirestoreUser'
import { getEffectiveServices } from '../../../../../utils/firebaseServiceContext'

interface UseEnvironmentalDataProps {
  uid: string
  firestoreUser: FirestoreUser
}

export const useEnvironmentalData = ({ uid, firestoreUser }: UseEnvironmentalDataProps) => {
  const [exposureHistory, setExposureHistory] = useState<ExposureData[]>([])
  const [initialExposureHistory, setInitialExposureHistory] = useState<ExposureData[]>([])

  const userAge = useMemo(() => {
    const birthDate = firestoreUser.profile?.birthDate
    if (!birthDate) return undefined
    return calculateAge(birthDate)
  }, [firestoreUser])

  useEffect(() => {
    async function fetchExposureHistory() {
      if (!uid) {
        alert('Not logged in!')
        return
      }
      
      const userRef = doc(getEffectiveServices().firestore, 'users', uid)
      const userDoc = await getDoc(userRef)
      
      if (userDoc.exists()) {
        const data = userDoc.data()
        const exposureData = data.medicalDetails?.exposureHistory || []
        setExposureHistory(exposureData)
        setInitialExposureHistory(exposureData)
      }
    }

    fetchExposureHistory()
  }, [uid])

  return {
    exposureHistory,
    setExposureHistory,
    initialExposureHistory,
    userAge,
  }
}

export default useEnvironmentalData
